function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import * as PropTypes from 'prop-types';
import SpzaComponent from '@shared/components/spzaComponent';
import { attachClickHandlerToElement } from '@shared/utils/appUtils';
import { Constants } from '@shared/utils/constants';
import { getWindow } from 'services/window';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { logger } from '@src/logger';
export class Footer extends SpzaComponent {
    componentDidMount() {
        const { toggleContextPanel } = this.props;
        const handleShowContextPanel = ()=>{
            return (event)=>{
                const payload = {
                    page: this.props.location.pathname,
                    action: Constants.Telemetry.Action.Country,
                    actionModifier: Constants.Telemetry.ActionModifier.FooterLocale
                };
                this.instrument.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
                logger.info(payload.details, {
                    page: payload.page,
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
                toggleContextPanel();
                event.preventDefault();
            };
        };
        // locale picker
        attachClickHandlerToElement('locale-picker-link', handleShowContextPanel());
        this.manageCookiesBtn();
    }
    componentDidUpdate() {
        this.manageCookiesBtn();
    }
    // manage Cookies button in Appsource footer.
    manageCookiesBtn() {
        const hiddenClass = 'x-hidden';
        if (document && document.getElementById(Constants.Cookies.WCPManageCookieBtnId) && document.getElementById(Constants.Cookies.WCPManageCookieBtnId).className.indexOf(hiddenClass) >= 0 && this.props.isManageCookieBtnRequired) {
            const manageCookieOnClick = ()=>{
                const telemetryData = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.ConsentBanner,
                    actionModifier: Constants.Telemetry.ActionModifier.Info,
                    details: 'manage button clicked'
                };
                SpzaInstrumentService.getProvider().probe('logTelemetryInfo', telemetryData);
                logger.info(telemetryData.details, {
                    action: telemetryData.action,
                    actionModifier: telemetryData.actionModifier
                });
                this.props.openCookieManagementModal();
            };
            document.getElementById(Constants.Cookies.WCPManageCookieBtnId).classList.remove(hiddenClass);
            attachClickHandlerToElement(Constants.Cookies.WCPManageCookieBtnId, manageCookieOnClick);
        }
    }
    renderImpl() {
        return null;
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "instrument", void 0);
        this.instrument = SpzaInstrumentService.getProvider();
    }
}
Footer.contextTypes = {
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
